import { render, staticRenderFns } from "./ListarRelatoriosLogValidacaoComprovacao.vue?vue&type=template&id=8553e234&scoped=true&"
import script from "./ListarRelatoriosLogValidacaoComprovacao.vue?vue&type=script&lang=js&"
export * from "./ListarRelatoriosLogValidacaoComprovacao.vue?vue&type=script&lang=js&"
import style0 from "./ListarRelatoriosLogValidacaoComprovacao.vue?vue&type=style&index=0&id=8553e234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8553e234",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VRow,VTextField})
